import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';

import { HtmlContent } from '../../global-component-styles';
import GlobalStyles from '../../global-styles';
import { generateUUID } from '../../utils/helper';
import { GetAppToneIcon } from '../../utils/icons';
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton,
  Typography
} from '../../utils/material-ui-core';
import Wait from '../wait';

interface ConfirmProps {
  content: string;
  okText: string;
  open: boolean;
  loading: boolean;
  callbackOnClose: () => void;
}

const LogViewer = ({ content, okText, open, loading, callbackOnClose }: ConfirmProps) => {
  const pageStyles = LocalPageStyles();
  const globalStyles = GlobalStyles();

  const downloadTxtFile = () => {
    const element = document.createElement("a");
    const file = new Blob([content], {
      type: "text/plain",
    });
    element.href = URL.createObjectURL(file);
    element.download = "File" + generateUUID() + ".txt";
    document.body.appendChild(element);
    element.click();
  };

  const getFormattedContent = (val: string) => {
    let returnContent = val;

    try {
      returnContent = returnContent.replaceAll("<html>", "");
      returnContent = returnContent.replaceAll("</html>", "");
      returnContent = returnContent.replaceAll("<body>", "");
      returnContent = returnContent.replaceAll("</body>", "");
      returnContent = returnContent.replaceAll("<head>", "");
      returnContent = returnContent.replaceAll("</head>", "");
    } catch (e) { }

    return returnContent;
  };

  return (
    <Dialog className={globalStyles.dialogContainer} open={open} maxWidth={"lg"} fullWidth={true}>
      <DialogTitle id="input-dialog-title" className={globalStyles.dialogTitleContainer}>
        <Typography variant="subtitle1" component="div">
          View Log
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {loading ? (
          <Wait />
        ) : (
          <DialogContentText className={pageStyles.contentText} component="div">
            <Box component="div">
              <HtmlContent
                dangerouslySetInnerHTML={{
                  __html: getFormattedContent(content),
                }}
              />
            </Box>
          </DialogContentText>
        )}
      </DialogContent>
      <DialogActions>
        <IconButton onClick={() => downloadTxtFile()}>
          <GetAppToneIcon color="primary" />
        </IconButton>
        <Button onClick={() => callbackOnClose()} color="secondary" variant="contained" autoFocus className={globalStyles.buttonDefault}>
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const LocalPageStyles = makeStyles((theme: Theme) =>
  createStyles({
    contentText: {
      "& ul": {
        maxHeight: "350px",
        overflow: "auto",
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[600] : "#edf6f5",
      },
      "& li": {
        listStyle: "none",
      },
      "& h1": {
        color: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.secondary.main,
        fontSize: "24px",
      },
      "& h2": {
        backgroundColor: theme.palette.type === "dark" ? theme.palette.grey[900] : theme.palette.grey[200],
        borderLeftWidth: 5,
        borderLeftColor: theme.palette.type === "dark" ? theme.palette.grey[700] : theme.palette.primary.light,
        borderLeftStyle: "solid",
        fontSize: 18,
        padding: theme.spacing(1),
        marginBottom: theme.spacing(1),
        marginTop: theme.spacing(5),
      },
      "& table": {
        paddingTop: theme.spacing(2),
        borderWidth: 0,
        borderColor: "transparent",
        borderStyle: "solid",
        borderSpacing: 0,
        width: "100%",
        maxWidth: "1000px",
        paddingRight: "30px",
        "& th": {
          borderWidth: 1,
          borderColor: theme.palette.grey[300],
          borderStyle: "solid",
          borderSpacing: 0,
          fontSize: 12,
          padding: "5px",
          verticalAlign: "top",
        },
        "& td": {
          borderWidth: 1,
          borderColor: theme.palette.grey[300],
          borderStyle: "solid",
          borderSpacing: 0,
          fontSize: 18,
          textAlign: "left",
          padding: "5px",
          verticalAlign: "top",
        },
      },
    },
  })
);

export default LogViewer;
